/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React from 'react';
import styled from 'styled-components';

import america from '../img/americarental.png';
import houston from '../img/houston.png';
import waiter from '../img/waiter.png';
import weather from '../img/weather.png';
import erp from '../img/erp.png';

export default function Projects() {
  const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-height: max-content;
    min-height: 90vh;

    @media (max-width: 1000px) {
      flex-wrap: wrap;
    }
  `;

  const Div = styled.div`
    width: 90%;
    display: flex;
    flex-wrap: wrap;
    margin: auto;
  `;

  const H1 = styled.h1`
    width: max-content;
    margin: 1rem auto;
    color: white;
  `;

  const H3 = styled.h3`
    width: max-content;
    margin: 2rem auto;
    color: #d1d1d1;

    @media (max-width: 1000px) {
      width: 90vw;
      margin: auto;
      text-align: center;
    }
  `;

  const ProjectContainer = styled.div`
    display: flex;
    flex-direction: ${(props) => props.reverse || 'row'};
    padding: 2.3rem;
    align-items: center;
    justify-content: center;
    margin: auto;
    max-width: 75vw;

    @media (max-width: 1000px) {
      flex-direction: column;
    }
  `;

  const PTitle = styled.h1`
    width: max-content;
    margin: auto;
    color: #57886c;
  `;

  const PSubtitle = styled.p`
    width: 80%;
    margin: 2rem auto;
    color: #ffffff;
    font-size: 1.1rem;

    @media (max-width: 1000px) {
      width: 100%;
      margin: 1rem auto;
      font-size: 1rem;
      letter-spacing: 0.05em;
    }
  `;

  const Img = styled.img`
    width: 28%;
    height: auto;

    @media (max-width: 1000px) {
      width: 100%;
      margin-bottom: 8px;
    }
  `;

  const Description = styled.div`
    display: flex;
    flex-direction: column;
  `;

  const A = styled.a`
    text-decoration: none;
    color: #57886c;
  `;

  return (
    <Container>
      <H1>Experiência</H1>
      <H3>
        Aqui estão minhas experiências e projetos que atuei, alguns estão
        disponíveis publicamente no meu
        <A href="http://www.github.com/5gMurilo" target="_blank">
          Github
        </A>
      </H3>

      <Div>
        <ProjectContainer>
          <Img src={waiter} alt="waiter" />
          <Description>
            <PTitle>Waiter App</PTitle>
            <PSubtitle>
              Esse aplicativo foi desenvolvido em React Native, utilizando o
              TypeScript e fazendo requisições a uma API Rest desenvolvida em
              Node JS conectada ao banco de dados MongoDB. O aplicativo busca
              enviar solicitações a cozinha de um restaurante, onde a cozinha
              teria acesso a um painel com todos os pedidos em um sistema
              desenvolvido em Next.JS.
            </PSubtitle>
          </Description>
        </ProjectContainer>

        <ProjectContainer reverse="row-reverse">
          <Img src={houston} alt="houston" />
          <Description>
            <PTitle>Houston</PTitle>
            <PSubtitle>
              O projeto carinhosamente apelidado de Houston, foi desenvolvido
              para documentar e implementar um procedimento antes não existente,
              para solicitações de manutenções a serem realizadas pelo
              departamento de T.I. Esse projeto foi desenvolvido em React JS
              utilizando o Vite como CLI e TypeScript como linguagem.
            </PSubtitle>
            <PSubtitle>
              Toda a comunicação é realizada através de uma comunicação com a
              API desenvolvida em Node JS, conectada a um banco de dados e
              acessando o serviço Sendgrid provido pela Twilio para realizar o
              envio de e-mails para o time de T.I. e seus gestores.
            </PSubtitle>
          </Description>
        </ProjectContainer>

        <ProjectContainer>
          <Img src={weather} alt="Aplicativo de clima" />
          <Description>
            <PTitle>Clima</PTitle>
            <PSubtitle>
              O aplicativo de clima foi desenvolvido em Flutter, utilizando o
              Dio para realizar as requisições à
              <A href="https://openweathermap.org/api" target="_blank">
                Open Weather - Weather API
              </A>
              .
            </PSubtitle>
            <PSubtitle>
              O intuíto desse projeto foi colocar em prática conceitos como,
              gerenciamento de estado, arquitetura MVVM, desenvolvimento
              orientado a testes (TDD) e consumo de APIs com o Flutter.
            </PSubtitle>
          </Description>
        </ProjectContainer>

        <ProjectContainer reverse="row-reverse">
          <Img src={america} alt="thumbnail" />
          <Description>
            <PTitle>América Rental</PTitle>
            <PSubtitle>
              Trabalhando na América Rental, atuei desde a infraestrutura de TI,
              até o desenvolvimento de site institucional, desenvolvimento de
              sistemas internos e otimização do SEO para uma maior presença
              online.
            </PSubtitle>
          </Description>
        </ProjectContainer>

        <ProjectContainer>
          <Img
            src={erp}
            alt="Aplicativo de clima"
          />
          <Description>
            <PTitle>ERP Rental</PTitle>
            <PSubtitle>
              O ERP Rental é um projeto freelancer, onde eu realizei a
              construção de um front-end em React com typescript e back-end
              utilizando Spring de forma inicialmente, o cliente optou por uma
              economia maior de recursos, portanto o back-end está sendo
              transportado para a linguagem Go.
            </PSubtitle>
            <PSubtitle>
              O ERP Rental tem como foco, integrar todos os setores de uma
              empresa, melhorando a qualidade de gestão de departamentos,
              aumento da produtividade e a possibilidade de promover o trabalho
              remoto de forma simples. Ainda está sobre estudo do cliente um
              aplicativo que complemente o sistema.
            </PSubtitle>
          </Description>
        </ProjectContainer>
      </Div>
    </Container>
  );
}
